export default {"src":"/_next/static/media/insider-in.2edccbfd.svg","height":141,"width":220,"blurWidth":0,"blurHeight":0};